import { render, staticRenderFns } from "./LogoSizeSlider.vue?vue&type=template&id=c8cdf85e&"
import script from "./LogoSizeSlider.vue?vue&type=script&lang=js&"
export * from "./LogoSizeSlider.vue?vue&type=script&lang=js&"
import style0 from "./LogoSizeSlider.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSlider});
